(function($) {
	"use strict";

	window.applangaHelpers = {};

	/**
	 * Checks if an html element got loaded and execute the given code if found. If not
	 * it keeps on retrying till the max tries got reached and then simply stops
	 */
	window.applangaHelpers.executeWhenExist = function(cssSelector, maxTries, pauseTime, executeFunction) {
		if ($(cssSelector).length === 0) {
			// Does not exist so check if we should try again
			if (maxTries > 1) {
				setTimeout(function() {
					window.applangaHelpers.executeWhenExist(cssSelector, --maxTries, pauseTime, executeFunction)
				}, pauseTime);
			}
		} else {
			// Exists so execute
			executeFunction();
		}
	}

})(jQuery);
